import { Controller } from "@hotwired/stimulus"
import Formatter from "../lib/formatter"

export default class extends Controller {
  static targets = [ "cancel", "cpf", "phone" ]

  submit() {
    this.element.requestSubmit()
  }

  cancel() {
    this.cancelTarget?.click()
  }

  preventAttachment(event) {
    event.preventDefault()
  }

  formatCpf(event) {
    const input = event.target
    input.value = Formatter.cpf(input.value)
  }

  formatPhone(event) {
    const input = event.target
    input.value = Formatter.phone(input.value)
  }
}
